import { render, staticRenderFns } from "./pms-demo.vue?vue&type=template&id=6fe49be6"
import script from "./pms-demo.vue?vue&type=script&lang=js"
export * from "./pms-demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports